// TICKET-7 🔴 Fichier sans aucun test (13 lignes, logique de filtrage projet)
// À tester dans estimation.test.ts (projets actifs/archivés liés aux estimations)

import { ProjectContext } from '@shared/types';

export function isArchivedProject(project?: Pick<ProjectContext, 'archivedAt'> | null): boolean {
  return Boolean(project?.archivedAt);
}

export function getActiveProjects(projects: ProjectContext[]): ProjectContext[] {
  return projects.filter((project) => !isArchivedProject(project));
}

export function getArchivedProjects(projects: ProjectContext[]): ProjectContext[] {
  return projects.filter((project) => isArchivedProject(project));
}
